(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _navigation = require("./modules/navigation");

require("./modules/class_polyfill");

(0, _navigation.nav)(".mobile_nav_btn"); // add class open and close

var hompeage_container = document.getElementById("homepage_hero_container");
var homepage_video = document.getElementById("homepage_video_container");
var homepage_placeholder_img = document.getElementById("homepage_hero_img"); // homepage_video.style.display = 'none';
// homepage_placeholder_img.style.display = 'block';
// if (typeof Vimeo === "undefined") {
//   console.log("vimeo is undefined", typeof Vimeo);
// }

var intervalCounter = 0;

function homeVideoCheckLoaded() {
  console.log("trying to load homepage vimeo player script"); // CHECK 50 TIMES

  intervalCounter++;
  console.log(intervalCounter);

  if (intervalCounter > 50) {
    clearInterval(videoLoadedIntervalID);
    videoLoadedIntervalID = null;
  }

  if (hompeage_container && typeof Vimeo != "undefined") {
    clearInterval(videoLoadedIntervalID);
    videoLoadedIntervalID = null;
    setupHomeVideo();
  }
}

function setupHomeVideo() {
  console.log("homepage container");
  var iframe = document.querySelector("#homepage_video_container iframe");
  var player = new Vimeo.Player(iframe);
  hompeage_container.addEventListener("click", function (event) {
    console.log("click");
    playVimeoVideo();
    window.setTimeout(function () {
      homepage_video.style.display = "block";
      homepage_video.style.position = "relative";
      homepage_video.style.opacity = "1";
      homepage_placeholder_img.style.display = "none";
    }, 600);
  });
  console.log("loaded");
  console.log("loaded");

  function videoEnded() {
    homepage_video.style = "";
    homepage_placeholder_img.style.display = "block";
  }

  function playVimeoVideo() {
    player.play().then(function () {})["catch"](function (error) {
      console.log(error.name);
    });
    player.on("ended", videoEnded);
  }
}

var videoLoadedIntervalID = setInterval(homeVideoCheckLoaded, 100); // ----------------------------------------------------------------------
// ----------------------------------------------------------------------
// Get all buttons as a NodeList
// var btns = document.querySelectorAll('button');
// Convert buttons NodeList to an array
// var btnsArr = Array.prototype.slice.call(btns);
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------

var dropdown = document.querySelector(".select-perspectives");

if (dropdown) {
  var cards = document.querySelectorAll(".js_story_card");
  var visibleCards;
  console.log(cards);
  dropdown.addEventListener("change", function (event) {
    console.log(event.target.value); // ----------------------------------------------------------------------
    // hide and show based on drop down selection

    for (var i = 0; i < cards.length; i++) {
      if (event.target.value == "All") {
        cards[i].style.display = "grid";
        cards[i].classList.add("visible");
        cards[i].classList.add("hidden");
      } else {
        if (cards[i].classList.contains(event.target.value)) {
          cards[i].style.display = "grid";
          cards[i].classList.add("visible");
          cards[i].classList.remove("hidden");
        } else {
          cards[i].style.display = "none";
          cards[i].classList.add("hidden");
          cards[i].classList.remove("visible");
        }
      }
    } // ----------------------------------------------------------------------
    // resort stripes on cards


    visibleCards = document.querySelectorAll(".visible.js_story_card");

    for (var i = 0; i < visibleCards.length; i++) {
      if (i % 2) {
        visibleCards[i].style.backgroundColor = "#ffffff";
      } else {
        visibleCards[i].style.backgroundColor = "#f1f2f2";
      }
    }
  });
} // Portfolio dropdown
// Status & Industry
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------


var statusDropdown = document.getElementById("selectStatus");
var industryDropdown = document.getElementById("selectIndustry");

if (statusDropdown && industryDropdown) {
  var portfolioCompanies = document.querySelectorAll(".b_grid_module_home");
  var portfolioContainer = document.querySelector(".b_grid");
  console.log("portfolioCompanies", portfolioCompanies); // Add top leve categories to the container

  statusDropdown.addEventListener("change", function (event) {
    portfolioContainer.classList.remove("Active");
    portfolioContainer.classList.remove("Realized");
    portfolioContainer.classList.remove("Status_all");
    portfolioContainer.classList.add(event.target.value);
  });
  industryDropdown.addEventListener("change", function (event) {
    console.log(event.target.value);
    portfolioContainer.classList.remove("Business_Services");
    portfolioContainer.classList.remove("Consumer_Products__Food");
    portfolioContainer.classList.remove("Healthcare");
    portfolioContainer.classList.remove("IT__Technology");
    portfolioContainer.classList.remove("Industrial__Distribution");
    portfolioContainer.classList.remove("Infrastructure_Services__Building_Products");
    portfolioContainer.classList.remove("Industry_all");
    portfolioContainer.classList.add(event.target.value);
  });
}

},{"./modules/class_polyfill":2,"./modules/navigation":3}],2:[function(require,module,exports){
"use strict";

// 1. String.prototype.trim polyfill
if (!"".trim) String.prototype.trim = function () {
  return this.replace(/^[\s﻿]+|[\s﻿]+$/g, '');
};

(function (window) {
  "use strict"; // prevent global namespace pollution

  if (!window.DOMException) (DOMException = function DOMException(reason) {
    this.message = reason;
  }).prototype = new Error();

  var wsRE = /[\11\12\14\15\40]/,
      wsIndex = 0,
      checkIfValidClassListEntry = function checkIfValidClassListEntry(O, V) {
    if (V === "") throw new DOMException("Failed to execute '" + O + "' on 'DOMTokenList': The token provided must not be empty.");
    if ((wsIndex = V.search(wsRE)) !== -1) throw new DOMException("Failed to execute '" + O + "' on 'DOMTokenList': " + "The token provided ('" + V[wsIndex] + "') contains HTML space characters, which are not valid in tokens.");
  }; // 2. Implement the barebones DOMTokenList livelyness polyfill


  if (typeof DOMTokenList !== "function") (function (window) {
    var document = window.document,
        Object = window.Object,
        hasOwnProp = Object.prototype.hasOwnProperty;
    var defineProperty = Object.defineProperty,
        allowTokenListConstruction = 0,
        skipPropChange = 0;

    function DOMTokenList() {
      if (!allowTokenListConstruction) throw TypeError("Illegal constructor"); // internally let it through
    }

    DOMTokenList.prototype.toString = DOMTokenList.prototype.toLocaleString = function () {
      return this.value;
    };

    DOMTokenList.prototype.add = function () {
      a: for (var v = 0, argLen = arguments.length, val = "", ele = this[" uCL"], proto = ele[" uCLp"]; v !== argLen; ++v) {
        val = arguments[v] + "", checkIfValidClassListEntry("add", val);

        for (var i = 0, Len = proto.length, resStr = val; i !== Len; ++i) {
          if (this[i] === val) continue a;else resStr += " " + this[i];
        }

        this[Len] = val, proto.length += 1, proto.value = resStr;
      }

      skipPropChange = 1, ele.className = proto.value, skipPropChange = 0;
    };

    DOMTokenList.prototype.remove = function () {
      for (var v = 0, argLen = arguments.length, val = "", ele = this[" uCL"], proto = ele[" uCLp"]; v !== argLen; ++v) {
        val = arguments[v] + "", checkIfValidClassListEntry("remove", val);

        for (var i = 0, Len = proto.length, resStr = "", is = 0; i !== Len; ++i) {
          if (is) {
            this[i - 1] = this[i];
          } else {
            if (this[i] !== val) {
              resStr += this[i] + " ";
            } else {
              is = 1;
            }
          }
        }

        if (!is) continue;
        delete this[Len], proto.length -= 1, proto.value = resStr;
      }

      skipPropChange = 1, ele.className = proto.value, skipPropChange = 0;
    };

    window.DOMTokenList = DOMTokenList;

    function whenPropChanges() {
      var evt = window.event,
          prop = evt.propertyName;

      if (!skipPropChange && (prop === "className" || prop === "classList" && !defineProperty)) {
        var target = evt.srcElement,
            protoObjProto = target[" uCLp"],
            strval = "" + target[prop];
        var tokens = strval.trim().split(wsRE),
            resTokenList = target[prop === "classList" ? " uCL" : "classList"];
        var oldLen = protoObjProto.length;

        a: for (var cI = 0, cLen = protoObjProto.length = tokens.length, sub = 0; cI !== cLen; ++cI) {
          for (var innerI = 0; innerI !== cI; ++innerI) {
            if (tokens[innerI] === tokens[cI]) {
              sub++;
              continue a;
            }
          }

          resTokenList[cI - sub] = tokens[cI];
        }

        for (var i = cLen - sub; i < oldLen; ++i) {
          delete resTokenList[i];
        } //remove trailing indexs


        if (prop !== "classList") return;
        skipPropChange = 1, target.classList = resTokenList, target.className = strval;
        skipPropChange = 0, resTokenList.length = tokens.length - sub;
      }
    }

    function polyfillClassList(ele) {
      if (!ele || !("innerHTML" in ele)) throw TypeError("Illegal invocation");
      ele.detachEvent("onpropertychange", whenPropChanges); // prevent duplicate handler infinite loop

      allowTokenListConstruction = 1;

      try {
        var _protoObj = function _protoObj() {};

        _protoObj.prototype = new DOMTokenList();
      } finally {
        allowTokenListConstruction = 0;
      }

      var protoObjProto = protoObj.prototype,
          resTokenList = new protoObj();

      a: for (var toks = ele.className.trim().split(wsRE), cI = 0, cLen = toks.length, sub = 0; cI !== cLen; ++cI) {
        for (var innerI = 0; innerI !== cI; ++innerI) {
          if (toks[innerI] === toks[cI]) {
            sub++;
            continue a;
          }
        }

        this[cI - sub] = toks[cI];
      }

      protoObjProto.length = cLen - sub, protoObjProto.value = ele.className, protoObjProto[" uCL"] = ele;

      if (defineProperty) {
        defineProperty(ele, "classList", {
          // IE8 & IE9 allow defineProperty on the DOM
          enumerable: 1,
          get: function get() {
            return resTokenList;
          },
          configurable: 0,
          set: function set(newVal) {
            skipPropChange = 1, ele.className = protoObjProto.value = newVal += "", skipPropChange = 0;
            var toks = newVal.trim().split(wsRE),
                oldLen = protoObjProto.length;

            a: for (var cI = 0, cLen = protoObjProto.length = toks.length, sub = 0; cI !== cLen; ++cI) {
              for (var innerI = 0; innerI !== cI; ++innerI) {
                if (toks[innerI] === toks[cI]) {
                  sub++;
                  continue a;
                }
              }

              resTokenList[cI - sub] = toks[cI];
            }

            for (var i = cLen - sub; i < oldLen; ++i) {
              delete resTokenList[i];
            } //remove trailing indexs

          }
        });
        defineProperty(ele, " uCLp", {
          // for accessing the hidden prototype
          enumerable: 0,
          configurable: 0,
          writeable: 0,
          value: protoObj.prototype
        });
        defineProperty(protoObjProto, " uCL", {
          enumerable: 0,
          configurable: 0,
          writeable: 0,
          value: ele
        });
      } else {
        ele.classList = resTokenList, ele[" uCL"] = resTokenList, ele[" uCLp"] = protoObj.prototype;
      }

      ele.attachEvent("onpropertychange", whenPropChanges);
    }

    try {
      // Much faster & cleaner version for IE8 & IE9:
      // Should work in IE8 because Element.prototype instanceof Node is true according to the specs
      window.Object.defineProperty(window.Element.prototype, "classList", {
        enumerable: 1,
        get: function get(val) {
          if (!hasOwnProp.call(this, "classList")) polyfillClassList(this);
          return this.classList;
        },
        configurable: 0,
        set: function set(val) {
          this.className = val;
        }
      });
    } catch (e) {
      // Less performant fallback for older browsers (IE 6-8):
      window[" uCL"] = polyfillClassList; // the below code ensures polyfillClassList is applied to all current and future elements in the doc.

      document.documentElement.firstChild.appendChild(document.createElement('style')).styleSheet.cssText = '_*{x-uCLp:expression(!this.hasOwnProperty("classList")&&window[" uCL"](this))}' + //  IE6
      '[class]{x-uCLp/**/:expression(!this.hasOwnProperty("classList")&&window[" uCL"](this))}' //IE7-8
      ;
    }
  })(window); // 3. Patch in unsupported methods in DOMTokenList

  (function (DOMTokenListProto, testClass) {
    if (!DOMTokenListProto.item) DOMTokenListProto.item = function (i) {
      function NullCheck(n) {
        return n === void 0 ? null : n;
      }

      return NullCheck(this[i]);
    };
    if (!DOMTokenListProto.toggle || testClass.toggle("a", 0) !== false) DOMTokenListProto.toggle = function (val) {
      if (arguments.length > 1) return this[arguments[1] ? "add" : "remove"](val), !!arguments[1];
      var oldValue = this.value;
      return this.remove(oldValue), oldValue === this.value && (this.add(val), true)
      /*|| false*/
      ;
    };
    if (!DOMTokenListProto.replace || typeof testClass.replace("a", "b") !== "boolean") DOMTokenListProto.replace = function (oldToken, newToken) {
      checkIfValidClassListEntry("replace", oldToken), checkIfValidClassListEntry("replace", newToken);
      var oldValue = this.value;
      return this.remove(oldToken), this.value !== oldValue && (this.add(newToken), true);
    };
    if (!DOMTokenListProto.contains) DOMTokenListProto.contains = function (value) {
      for (var i = 0, Len = this.length; i !== Len; ++i) {
        if (this[i] === value) return true;
      }

      return false;
    };
    if (!DOMTokenListProto.forEach) DOMTokenListProto.forEach = function (f) {
      if (arguments.length === 1) for (var i = 0, Len = this.length; i !== Len; ++i) {
        f(this[i], i, this);
      } else for (var i = 0, Len = this.length, tArg = arguments[1]; i !== Len; ++i) {
        f.call(tArg, this[i], i, this);
      }
    };
    if (!DOMTokenListProto.entries) DOMTokenListProto.entries = function () {
      var nextIndex = 0,
          that = this;
      return {
        next: function next() {
          return nextIndex < that.length ? {
            value: [nextIndex, that[nextIndex]],
            done: false
          } : {
            done: true
          };
        }
      };
    };
    if (!DOMTokenListProto.values) DOMTokenListProto.values = function () {
      var nextIndex = 0,
          that = this;
      return {
        next: function next() {
          return nextIndex < that.length ? {
            value: that[nextIndex],
            done: false
          } : {
            done: true
          };
        }
      };
    };
    if (!DOMTokenListProto.keys) DOMTokenListProto.keys = function () {
      var nextIndex = 0,
          that = this;
      return {
        next: function next() {
          return nextIndex < that.length ? {
            value: nextIndex,
            done: false
          } : {
            done: true
          };
        }
      };
    };
  })(window.DOMTokenList.prototype, window.document.createElement("div").classList);
})(window);

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nav = nav;

// add code for adding class and removing class
// thanks
function nav(nav_btn_dom) {
  // get mobile burger
  var mobile_nav_btn = document.querySelector(nav_btn_dom);
  mobile_nav_btn.addEventListener('click', nav_button_click);

  function nav_button_click(event) {
    event.preventDefault();
    toggle_nav();
  }

  function remove_class(dom_elem, remove_class) {
    if (dom_elem.classList.contains(remove_class)) {
      dom_elem.classList.remove(remove_class);
    } else {
      console.log('nothing to remove');
    }
  }

  function add_class(dom_elem, append_class) {
    dom_elem.classList.add(append_class);
  }

  function class_existance(dom_elem, class_exist) {
    if (dom_elem.classList.contains(class_exist)) {
      return true;
    } else {
      return false;
    }
  }

  function toggle_nav() {
    if (class_existance(mobile_nav_btn, 'open')) {
      remove_class(mobile_nav_btn, 'open');
      add_class(mobile_nav_btn, 'close');
    } else {
      add_class(mobile_nav_btn, 'open');
      remove_class(mobile_nav_btn, 'close');
    }
  }
}

},{}]},{},[1]);
